<template>
  <section class="heading">
    <h2 v-if="content" class="view-head-title h1">{{ content.home.title }}</h2>
    <div class="view-bottom-text typeset" v-html="content.home.text"></div>
  </section>
</template>

<script>
export default {
  computed: {
    content() {
      // console.log('desactivate', this.$store.state.exhibitions)
      return this.$store.state.exhibitions.item;
    }
  }
}
</script>

<style lang="scss" scoped>
  .heading {
    margin: 15px 0;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(#fff, .5);
  }
  .view-head-title {
    font-size: rem(21);
    margin-bottom: 15px;
  }

  .view-bottom-text  {
    font-size: rem(11px);
    color: rgba(#fff, .5)
  }
</style>